// extracted by mini-css-extract-plugin
module.exports = {"free":"ContactPhoto_free__2Qxiq","busy":"ContactPhoto_busy__1R5jx","photo":"ContactPhoto_photo__IXBmB","icon":"ContactPhoto_icon__2JYKv","error":"ContactPhoto_error__MJ_MZ"};